<template>
    <div class="component__qrcode">
        <div class="columns is-variable">
            <div class="column">
                <canvas id="component__qrcode_canvas"></canvas>
            </div>
        </div>
    </div>
</template>
<script>
import * as QRCode from 'qrcode'
export default {
  name: 'component-qrcode',
  data () {
    return {}
  },
  props: {
    secret: {
      type: String
    },
    label: {
      type: String
    },
    issuer: {
      type: String
    }
  },
  computed: {
    watchProps () {
      return this.secret + this.label + this.issuer
    }
  },
  watch: {
    watchProps () {
      if (this.secret && this.label && this.issuer) {
        this.renderValue()
      }
    }
  },
  methods: {
    renderValue () {
      const secret = this.secret
      const label = encodeURIComponent(`${this.issuer}:${this.label}`)
      const issuer = encodeURIComponent(this.issuer)
      const value = `otpauth://totp/${label}?secret=${secret}&issuer=${issuer}&choe=UTF-8`
      const canvas = document.getElementById('component__qrcode_canvas')
      QRCode.toCanvas(canvas, value, function (error) {
        if (error) console.error(error)
      })
    }
  },
  mounted () {
    if (this.secret && this.label && this.issuer) {
      this.renderValue()
    }
  }
}
</script>
<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componenttitle";
</style>
